module.exports = __webpack_public_path__ + "static/media/0602map.e6adf6df.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Media/0602map.png
// module id = 401
// module chunks = 0